import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=6f177c7e&lang=md&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.8_rqhk6tgffcjxa27soxhh2o2ymu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports